// extracted by mini-css-extract-plugin
export default {"image":"Tarifs_images_image__rp4Y0","top_image":"Tarifs_images_top_image__AZoB-","bottom_image":"Tarifs_images_bottom_image__5mYg7"};